import * as Yup from 'yup';
import { AnyObject, TestContext, ValidationError } from 'yup';
import { validateSn } from './snValidationScheme';

export const authorizedValidationSchemeAgent = (
  checkSn: (
    value: number,
    p: TestContext<AnyObject>
  ) => Promise<boolean | ValidationError>,
  computerRequired: boolean
) =>
  Yup.object({
    technician: Yup.string().required('This field is required'),
    sn: validateSn(checkSn),
    imo: Yup.number()
      .nullable()
      .optional()
      .transform((value, originalValue) =>
        originalValue === '' || originalValue == null ? undefined : value
      ),
    vessel: Yup.string()
      .optional()
      .transform((value) =>
        typeof value === 'string' && value.trim() === '' ? undefined : value
      ),
    computerSn: computerRequired
      ? Yup.number().required('This field is required')
      : Yup.number().optional(),
    dateOfCalibration: Yup.date().required('This field is required'),
    batchCalCheck: Yup.string().required('This field is required'),
    placeOfCalibration: Yup.string().required('This field is required'),
    cleanWaterValue: Yup.number().required('This field is required'),
    firstCheckIntended: Yup.number().required('This field is required'),
    firstCheckValue: Yup.number().required('This field is required'),
    secondCheckValue: Yup.number().required('This field is required'),
    secondCheckIntended: Yup.number().required('This field is required'),
  });

export const authorizedValidationSchemeCustomer = (
  checkSn: (
    value: number,
    p: TestContext<AnyObject>
  ) => Promise<boolean | ValidationError>,
  computerRequired: boolean
) =>
  Yup.object({
    sn: validateSn(checkSn),
    imo: Yup.number()
      .nullable()
      .optional()
      .transform((value, originalValue) =>
        originalValue === '' || originalValue == null ? undefined : value
      ),
    vessel: Yup.string()
      .optional()
      .transform((value) =>
        typeof value === 'string' && value.trim() === '' ? undefined : value
      ),
    email: Yup.string().required('This field is required'),
    computerSn: computerRequired
      ? Yup.number().required('This field is required')
      : Yup.number().optional(),
    produktionsdatum: Yup.string().required('This field is required'),
  });
